import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatIconPhone } from '@blocks-react/components/Icons/Phone';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { Conditional } from '../../../common';
export const DealerLocatorSearchResultMobileContact = ({ children, showPhoneIcon = false }) => (_jsxs(CatTextLink, { children: [_jsx(Conditional, { test: showPhoneIcon, children: _jsx(CatIconPhone, { className: "mt-1 me-2" }) }), children] }));
